import { useEffect, useState, useMemo } from 'react';

import {
  getTouchpoint,
  subscribeTouchpoint,
} from '@/utils/environment/touchpointResolver';
import {
  GENAI_STUDIO_TOUCHPOINT,
  isWebGenaiStudio,
} from '@/utils/environment/surface';

/**
 * React subscription to the singleton touchpoint resolver. Multiple
 * consumers share one polling loop (see touchpointResolver.ts).
 */
const useTouchpoint = () => {
  const [touchpoint, setTouchpoint] = useState<string | null>(getTouchpoint);

  useEffect(() => subscribeTouchpoint(setTouchpoint), []);

  return useMemo(() => {
    const isGenaiStudioTouchpoint = touchpoint === GENAI_STUDIO_TOUCHPOINT;

    return {
      touchpoint,
      isGenaiStudioTouchpoint,
      showUserMenu: isGenaiStudioTouchpoint || isWebGenaiStudio(),
    };
  }, [touchpoint]);
};

export default useTouchpoint;
